import * as $ from 'jquery';
import 'bootstrap';
import 'slick';

export class mobileSection {
	private mobileBody: any   = document.getElementById('mobile');
  private slideIndex: any = 1;
  private stopMobileAnimation: any = false;
  private isAnimationCompleted: any = false;
  initializaCarousel() {
    let self = this;
    let mobileElem = document.getElementsByClassName('mhexplorer-mobilecarousel');
    // first slide
    self.slideIndex = self.slideIndex + 1;
    self.showSlides(self);
    // onScroll();
    $('.prev').click(function() {
      self.slideIndex = self.slideIndex - 1;
      self.showSlides(self);
    });
    $('.next').click(function() {
      self.slideIndex = self.slideIndex + 1;
      self.showSlides(self);
    });
    function isElementInView() {
      const rect = mobileElem[0].getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom >= window.innerHeight &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)

      );
    }
    function onScroll() {
      let isInView = isElementInView();
      if(isInView && !self.isAnimationCompleted) {
        $('.one').addClass('rotate-in-down-left');
        $('.two').addClass('rotate-in-up-left');
        self.isAnimationCompleted = true;
        self.showSlides(self);
      }
      if(self.isAnimationCompleted) {
        setTimeout(() => {
          $('.one').removeClass('rotate-in-down-left');
        $('.two').removeClass('rotate-in-up-left');
        }, 1000);
      }
    }
    // Capture scroll events
    $(document.body).on('touchmove', onScroll);
    
    $(window).scroll(function(){
      let isInView = isElementInView();
      if(isInView && !self.isAnimationCompleted) {
        $('.one').addClass('rotate-in-down-left');
        $('.two').addClass('rotate-in-up-left');
        self.isAnimationCompleted = true;
        self.showSlides(self);
      }
      if(self.isAnimationCompleted) {
        setTimeout(() => {
          $('.one').removeClass('rotate-in-down-left');
        $('.two').removeClass('rotate-in-up-left');
        }, 1000);
      }
    });
  }
  showSlides(self: any) {
    let i;
    let slides = $(".desktop-slides");
    let ismobile = window.visualViewport.width <= 767;
    if(ismobile) {
      slides = $(".mobile-slides");
    }
    if (self.slideIndex > slides.length) {
      self.slideIndex = 1;
    }    
    if (self.slideIndex < 1) {
      self.slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
        $($(slides[i])[0].children[0]).removeClass('bounce-in-left');
        $($(slides[i])[0].children[0]).removeClass('fade-in');
        $($(slides[i])[0].children[1]).removeClass('bounce-in-left1');
        $($(slides[i])[0].children[1]).removeClass('fade-in');
    }
    slides[self.slideIndex-1].style.display = "block";
    if(!self.stopMobileAnimation) {
      $($(slides[self.slideIndex-1])[0].children[0]).addClass('bounce-in-left');
      $($(slides[self.slideIndex-1])[0].children[0]).removeClass('fade-in');
      $($(slides[self.slideIndex-1])[0].children[1]).addClass('bounce-in-left1');
      $($(slides[self.slideIndex-1])[0].children[1]).removeClass('fade-in');
    } else {
      $($(slides[self.slideIndex-1])[0].children[0]).addClass('bounce-in-left');
      $($(slides[self.slideIndex-1])[0].children[1]).addClass('bounce-in-left1');
      setTimeout(function() {
        $($(slides[self.slideIndex-1])[0].children[0]).removeClass('fade-in');
        $($(slides[self.slideIndex-1])[0].children[1]).removeClass('fade-in');
        $($(slides[self.slideIndex-1])[0].children[0]).removeClass('bounce-in-left');
        $($(slides[self.slideIndex-1])[0].children[1]).removeClass('bounce-in-left1')
      }, 2000);
    }
    setTimeout(function() {
      $($(slides[self.slideIndex-1])[0].children[0]).removeClass('bounce-in-left');
      $($(slides[self.slideIndex-1])[0].children[1]).removeClass('bounce-in-left1');
      self.stopMobileAnimation = true;
    }, 2000);
  }
  checkAnimation(self: any, className: any, addClassString: any) {
    var $elem = $('.'+className);
    if (self.isElementInViewport($elem)) {
      // Start the animation
      $elem.addClass(addClassString);
    } else {
      $elem.removeClass(addClassString);
    }
  }
}

let scope:Element = document.querySelector('#mobile');
if (scope) {
	try {
		let mobile = new mobileSection();
    mobile.initializaCarousel();
	} catch(e) {console.error(e);}
}